/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateReferralDocumentExport202ResponseData } from './CreateReferralDocumentExport202ResponseData';
import {
    CreateReferralDocumentExport202ResponseDataFromJSON,
    CreateReferralDocumentExport202ResponseDataFromJSONTyped,
    CreateReferralDocumentExport202ResponseDataToJSON,
    CreateReferralDocumentExport202ResponseDataToJSONTyped,
} from './CreateReferralDocumentExport202ResponseData';

/**
 * 
 * @export
 * @interface CreateReferralDocumentExport202Response
 */
export interface CreateReferralDocumentExport202Response {
    /**
     * 
     */
    data?: CreateReferralDocumentExport202ResponseData;
}

/**
 * Check if a given object implements the CreateReferralDocumentExport202Response interface.
 */
export function instanceOfCreateReferralDocumentExport202Response(value: object): value is CreateReferralDocumentExport202Response {
    return true;
}

export function CreateReferralDocumentExport202ResponseFromJSON(json: any): CreateReferralDocumentExport202Response {
    return CreateReferralDocumentExport202ResponseFromJSONTyped(json, false);
}

export function CreateReferralDocumentExport202ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReferralDocumentExport202Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CreateReferralDocumentExport202ResponseDataFromJSON(json['data']),
    };
}

export function CreateReferralDocumentExport202ResponseToJSON(json: any): CreateReferralDocumentExport202Response {
    return CreateReferralDocumentExport202ResponseToJSONTyped(json, false);
}

export function CreateReferralDocumentExport202ResponseToJSONTyped(value?: CreateReferralDocumentExport202Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateReferralDocumentExport202ResponseDataToJSON(value['data']),
    };
}

